import { DataLayerAnalytics } from './lib/pages/landing-page/models/analytics.interface';

// Expose Features
export * from './lib/features/index';
// Expose Pages
export * from './lib/pages/landing-page/landing-page.component';
export * from './lib/pages/landing-page/mocks/analytics.mocks';
export * from './lib/pages/landing-page/mocks/landing-page.mocks';
export * from './lib/pages/landing-page/models/analytics.interface';
export * from './lib/pages/landing-page/models/landing-page.interfaces';
export * from './lib/utils/adobe-analytics.utils';

export interface DataLayerWindow extends Window {
  adobeDataLayer: DataLayerAnalytics[];
}
